import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { ListItem } from "../ListItem";
import { useNavigate } from "react-router-dom";

export const Favorties = () => {
  const navigate = useNavigate();
  const userFavorites = useSelector(
    (state: any) => state.listingReducer.userFavorites
  );
  return (
    <div className="w-full p-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-900">Favourite</h3>
        <button onClick={() => navigate("/")} className="h-10 w-10">
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2">
        {userFavorites.map((fav: any) => (
          <ListItem key={fav.listing_unique_id} listing={fav} />
        ))}
      </div>
    </div>
  );
};
